import { createFileRoute, redirect } from "@tanstack/react-router";
import {
  parseCryptoAssetRouteParams,
  resolveCryptoAssetRouteParams,
  type CryptoAssetRouteParams,
} from "~/lib/crypto-asset-route";

export function parseExactCryptoRouteParams(
  rawParams: CryptoAssetRouteParams,
): CryptoAssetRouteParams {
  const parsed = parseCryptoAssetRouteParams(rawParams);
  if (!parsed) {
    return false as never;
  }

  return parsed;
}

export const Route = createFileRoute("/_app/crypto_/$chain/$tokenAddress")({
  params: {
    priority: 30,
    parse: parseExactCryptoRouteParams,
  },
  beforeLoad: ({ params }) => {
    const resolved = resolveCryptoAssetRouteParams(params);
    if (!resolved) {
      return;
    }

    if (
      params.chain !== resolved.chainSlug ||
      params.tokenAddress !== resolved.tokenAddress
    ) {
      throw redirect({
        params: {
          chain: resolved.chainSlug,
          tokenAddress: resolved.tokenAddress,
        },
        replace: true,
        to: "/crypto/$chain/$tokenAddress",
      });
    }
  },
  head: () => ({
    meta: [{ content: "noindex", name: "robots" }],
  }),
  loader: ({ context, params }) => {
    const resolved = resolveCryptoAssetRouteParams(params);
    if (!resolved) {
      return;
    }

    void import("~/features/asset/asset-route")
      .then(({ preloadAssetRoute }) =>
        preloadAssetRoute(context, {
          chainId: resolved.chainId,
          tokenAddress: resolved.tokenAddress,
        }),
      )
      .catch(() => {
        // Warmup is best-effort; the page's own queries surface real errors.
      });
  },
});
